<template>
    <div id="sidebar-wrapper">
            <ul class="sidebar-nav">
                <li class="sidebar-brand">
                    <a href="#">
                        <img :src="logo" alt="">
                    </a>
                </li>
                <li>
                    <router-link to="/">
                      <a>Home</a>
                    </router-link>
                </li>
                <li>
                    <router-link to="/produtos">
                      <a>Produtos</a>
                    </router-link>
                </li>
                <li>
                    <router-link to="/empresa">
                      <a>Empresa</a>
                    </router-link>
                </li>
                <li>
                    <router-link to="/representantes">
                      <a>Representantes</a>
                    </router-link>
                </li>
                <li>
                    <router-link to="/social">
                      <a>Social</a>
                    </router-link>
                </li>
                <li>
                    <router-link to="/trabalhe-conosco">
                      <a>Trabalhe conosco</a>
                    </router-link>
                </li>
                <li>
                    <router-link to="/downloads">
                      <a>Downloads</a>
                    </router-link>
                </li>
                <li>
                    <router-link to="/contato">
                      <a>Contato</a>
                    </router-link>
                </li>
                <li>
                    <router-link to="/nfe">
                      <a>NF-E</a>
                    </router-link>
                </li>
            </ul>
            <div class="menu-idiomas">
              <ul>
                <!-- <li><a href="http://funada-es.ataquepropaganda.com.br/"><img src="../assets/idiomas/spain.png" alt=""></a></li> -->
                <!-- <li><a href="http://funada-en.ataquepropaganda.com.br/"><img src="../assets/idiomas/usa.png" alt=""></a></li> -->
                <!-- <li><a href="http://jp-funada.ataquepropaganda.com.br/"><img src="../assets/idiomas/jp.png" alt=""></a></li> -->
                <!-- <li><a href="http://funada.ataquepropaganda.com.br/"><img src="../assets/idiomas/br.png" alt=""></a></li> -->
              </ul>
            </div>
            <div class="footer">
              <span>Copyright 2018 | all rights reserved</span>
              <ul>
                <li><img src="../assets/icons/facebook.png" alt=""></li>
                <li><img src="../assets/icons/twitter.png" alt=""></li>
                <li><img src="../assets/icons/instagram.png" alt=""></li>
              </ul>
            </div>
        </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require("../assets/logo.png"),
      sidebarHeader: true,
      sidebarContent: true,
      idiomas: []
    };
  }
};
</script>

<style scoped>
#sidebar-wrapper {
  z-index: 1;
  position: fixed;
  left: 370px;
  float: left;
  top: 0;
  width: 0;
  height: 100vh;
  margin-left: -370px;
  overflow-x: hidden;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#eac229),
    color-stop(#fefe01),
    to(#ebc228)
  );
  background: url('../assets/menu-bg.png'), linear-gradient(#eac229, #fefe01, #ebc228);
  -webkit-box-shadow: -2px 0 10px 0 #000000;
  box-shadow: -2px 0 10px 0 #000000;
}

.sidebar-nav {
  padding-top: 55px;
  padding-right: 50px;
  list-style: none;
  text-align: right;
  text-transform: uppercase;
}

.sidebar-nav li {
  text-indent: 20px;
  line-height: 40px;
  font-family: "Bambino";
  font-size: 10pt;
}

.sidebar-nav li a {
  display: block;
  text-decoration: none;
  color: #000;
}

.sidebar-nav li a:hover {
  text-decoration: none;
  color: #000;
}

.sidebar-nav li a:active,
.sidebar-nav li a:focus {
  text-decoration: none;
}

.sidebar-nav > .sidebar-brand {
  height: 105px;
  font-size: 18px;
  line-height: 60px;
  margin-bottom: 32px;
}

.sidebar-nav > .sidebar-brand a {
  color: #999999;
}

.sidebar-nav > .sidebar-brand a:hover {
  color: #fff;
  background: none;
}

.menu-idiomas {
  text-align: right;
  margin-right: 50px;
}

.menu-idiomas ul {
  list-style: none;
  display: inline-flex;
}

.menu-idiomas ul > li {
  margin-left: 15px;
}

.footer {
  text-transform: uppercase;
  font-family: "Bambino";
  font-size: 9pt;
  position: absolute;
  width: 100%;
  text-align: right;
  padding-right: 50px;
  bottom: 40px;
}

.footer ul {
  list-style: none;
  display: inline-flex;
  margin-top: 10px;
}

.footer ul>li {
  margin-left: 15px;
}

@media (min-width: 1025px) {
  #wrapper {
    padding-left: 0;
  }
  #wrapper.toggled {
    padding-left: 370px;
  }
  #sidebar-wrapper {
    width: 370px;
  }
  #wrapper.toggled #sidebar-wrapper {
    width: 370px;
  }
  #page-content-wrapper {
    padding: 20px;
    position: relative;
  }
  #wrapper.toggled #page-content-wrapper {
    position: relative;
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue